{
  "REGISTER": {
    "TRY_WOOT": "Creează cont",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Inregistrare",
    "TESTIMONIAL_HEADER": "Tot ce trebuie este un pas pentru a merge mai departe",
    "TESTIMONIAL_CONTENT": "Ești la un pas de a-ți angaja clienții, de a-i păstra și de a găsi altele noi.",
    "TERMS_ACCEPT": "Prin crearea unui cont, sunteți de acord cu <a href=\"https://www.chatwoot.com/terms\">T & C</a> și <a href=\"https://www.chatwoot.com/privacy-policy\">politica noastră de confidențialitate</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Înscrieți-vă cu Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Numele Companiei",
      "PLACEHOLDER": "Introduceți numele companiei dvs. de exemplu: Wayne Intreprinderi",
      "ERROR": "Numele companiei este prea scurt."
    },
    "FULL_NAME": {
      "LABEL": "Nume complet",
      "PLACEHOLDER": "Introduceți numele complet. de exemplu: Bruce Wayne",
      "ERROR": "Numele complet este prea scurt."
    },
    "EMAIL": {
      "LABEL": "E-mail de lucru",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă de lucru."
    },
    "PASSWORD": {
      "LABEL": "Parola",
      "PLACEHOLDER": "Parola",
      "ERROR": "Parola este prea scurta.",
      "IS_INVALID_PASSWORD": "Parola trebuie să conțină atleast 1 literă mare, 1 literă mică, 1 număr și 1 caracter special.",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmă parola",
      "PLACEHOLDER": "Confirmă parola",
      "ERROR": "Parola nu coincide."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
    },
    "SUBMIT": "Creează cont",
    "HAVE_AN_ACCOUNT": "Ai deja un cont?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Resend verification email",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
